<!--
 * @Description: 封面
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div>
      <span v-if="curItem.tips" class="bi-tmpl-detail__right__cmpt__tips">
        {{ curItem.tips }}
      </span>
    </div>
    <Carousel ref="carouselRef" :itemHeight="675" :itemWidth="420 + 56">
      <div v-for="(item, index) in TYPE_MAPPING" :key="index">
        <div
          class="xrk-card"
          @click="onChange(item.value)"
          style="width: 420px; height: 600px"
        >
          <div
            :style="{
              width: '100%',
              height: '600px',
              'border-radius': '2px',
              position: 'absolute',
              top: '0',
              left: '0'
            }"
          >
            <div
              style="
                transform: scale(0.36);
                width: 1163px;
                height: 1665px;
                transform-origin: 0px 0px;
                overflow: hidden;
              "
            >
              <component
                :is="cmpName(item.moduleType)"
                v-bind="getAttrs(item.moduleType)"
              />
            </div>
          </div>
        </div>
        <div class="bi-tmpl-detail__right__cmpt__radioBox">
          <BaseRadio
            :value="item.value"
            :model-value="curItem.value"
            @click="onChange(item.value)"
          >
            {{}}
          </BaseRadio>
        </div>
      </div>
    </Carousel>
  </div>
</template>

<script lang="ts" setup>
import PcModuleCover, {
  posDefaultConfig
} from '../bi-pc-module/pc-module-cover';

import { BaseRadio } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';

import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';

const getAttrs = (templateName: string) => ({
  projectName: '关于阿莫西林产品在全国区域的患者诊疗现状调研项目数据报告',
  time: '2024-01-31',
  mainPageEnterpriseName: '项目方：盛安制药有限公司',
  orderNumber: 'GSD1234567890123456',
  titlePosition: JSON.parse(posDefaultConfig[templateName].titlePosition),
  settleTimePosition: JSON.parse(
    posDefaultConfig[templateName].settleTimePosition
  ),
  aspNamePosition: JSON.parse(posDefaultConfig[templateName].aspNamePosition),
  orderNumberPostion: JSON.parse(
    posDefaultConfig[templateName].orderNumberPostion
  )
});

const TYPE_MAPPING = {
  1: {
    value: 'pc-module-cover-1',
    moduleType: 'pc-module-cover-1'
  },
  2: {
    value: 'pc-module-cover-2',
    moduleType: 'pc-module-cover-2'
  },
  3: {
    value: 'pc-module-cover-3',
    moduleType: 'pc-module-cover-3'
  },
  4: {
    value: 'pc-module-cover-4',
    moduleType: 'pc-module-cover-4'
  },
  5: {
    value: 'pc-module-cover-5',
    moduleType: 'pc-module-cover-5'
  },
  6: {
    value: 'pc-module-cover-6',
    moduleType: 'pc-module-cover-6'
  },
  7: {
    value: 'pc-module-cover-7',
    moduleType: 'pc-module-cover-7'
  },
  8: {
    value: 'pc-module-cover-8',
    moduleType: 'pc-module-cover-8'
  },
  9: {
    value: 'pc-module-cover-9',
    moduleType: 'pc-module-cover-9'
  },
  10: {
    value: 'pc-module-cover-10',
    moduleType: 'pc-module-cover-10'
  }
};

const cmpName = name => {
  return PcModuleCover.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange } = useDetailCmpt({});
</script>
<style lang="scss" scope></style>
